import Player from '@vimeo/player';
import { Component, ViewEncapsulation, Input, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'vimeo-pop-video',
    templateUrl: './vimeo-pop-video.component.html',
    styleUrls: ['./vimeo-pop-video.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class VimeoPopVideoComponent {
    @Output()
    public eventCloseComponent: EventEmitter<boolean> = new EventEmitter();

    @Input()
    public showComponent: boolean;

    @Input()
    public videoUrl;

    public player = null;

    constructor(protected sanitizer: DomSanitizer, 
        private hostElement: ElementRef) {}

    public async closeComponent() {
        //this.eventCloseComponent.emit();
        this.showComponent = false;
        this.stopVideo();
    }

    public getUrlSanitized() {
        return this.sanitizer.bypassSecurityTrustUrl(this.videoUrl);
    }

    public async ngOnChanges(changes) {
        if (this.showComponent) {
            this.playVideo();
        }
    }

    public getVideoElm() {
        const element = this.hostElement.nativeElement;
        const iframe = element.querySelector('iframe');
        const video = element.querySelector('video');

        return {
            video, iframe
        };
    }

    public playVideo() {
        this.videoUrl += '&autoplay=1';
    }

    public stopVideo() {
        const { video, iframe } = this.getVideoElm();

        if (iframe) {
            this.videoUrl = this.videoUrl.replace('&autoplay=1', '');
        }
        if (video) {
            video.pause();
        }
    }
}
